import AccountMarketingMaterialWeddingTableTentTemplate from './AccountMarketingMaterialWeddingTableTentTemplate';

export default AccountMarketingMaterialWeddingTableTentTemplate;
